module.exports = "module.exports = __webpack_public_path__ + \"static/media/audio.example.2ca80224.mp3\";";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./src/content/media/audio.example.mp3
// module id = 1477
// module chunks = 0